import * as tslib_1 from "tslib";
import { isNumeric } from '../../util/helpers';
import { parseLatLon } from '../../airport/util/parseUtils';
import { BusinessFinderResult } from './business-finder-result.model';
/**
 * Tag-name prefix carried by classification tags (Part 61 / Part 141 / ...). The last `::` segment is
 * shown on the results card as the school's training-type badge(s).
 */
export var FLIGHT_SCHOOL_CLASSIFICATION_PREFIX = 'Flight Training::Classification::';
/**
 * Tag name marking a school approved for VA (GI Bill) benefits.
 */
export var FLIGHT_SCHOOL_VA_APPROVED_TAG = 'Flight Training::VA Approved';
/**
 * A flight-school search result returned by the AirportsAPI `~/flight-schools` endpoint. A flight school
 * is a business carrying any "Flight Training" tag but NOT the "Flight Training::Private" tag (i.e. open to
 * the public), mirroring the iOS app's flight-school classification. Mirrors {@link FlyingClubResult}'s
 * `static parse` convention.
 */
var FlightSchoolResult = /** @class */ (function (_super) {
    tslib_1.__extends(FlightSchoolResult, _super);
    function FlightSchoolResult() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FlightSchoolResult.parse = function (data) {
        var tags = (data.tags || []).map(function (d) { return d; });
        var classifications = tags
            .filter(function (t) { return t.indexOf(FLIGHT_SCHOOL_CLASSIFICATION_PREFIX) === 0; })
            .map(function (t) { return t.substring(FLIGHT_SCHOOL_CLASSIFICATION_PREFIX.length); });
        return Object.assign(new FlightSchoolResult(), {
            businessId: data.businessId,
            name: data.name || null,
            city: data.city || null,
            stateProvince: data.stateProvince || null,
            latitude: isNumeric(data.latitude) ? +data.latitude : null,
            longitude: isNumeric(data.longitude) ? +data.longitude : null,
            location: (isNumeric(data.latitude) && isNumeric(data.longitude))
                ? parseLatLon(data.latitude, data.longitude) : null,
            phone1: data.phone1 || null,
            webAddress: data.webAddress || null,
            emailAddress: data.emailAddress || null,
            description: data.description || null,
            distance: isNumeric(data.distance) ? +data.distance : null,
            airportIdent: data.airportIdent || null,
            airportName: data.airportName || null,
            tags: tags,
            classifications: classifications,
            vaApproved: tags.indexOf(FLIGHT_SCHOOL_VA_APPROVED_TAG) !== -1,
            collegeName: data.collegeName || null,
            instructorFull: isNumeric(data.instructorFull) ? +data.instructorFull : null,
            instructorPart: isNumeric(data.instructorPart) ? +data.instructorPart : null,
            thumbnailPhotoPath: data.thumbnailPhotoPath || null
        });
    };
    return FlightSchoolResult;
}(BusinessFinderResult));
export { FlightSchoolResult };
